const localStorageKey = "disabledServices"
export default localStorageKey